export default __webpack_public_path__ + "static/media/hoverCircle.f202fd0c.svg";